// extracted by mini-css-extract-plugin
export var assigneeBadge = "_hh-0";
export var assigneeDetails = "_hh-1";
export var assigneeInfo = "_hh-2";
export var dropdownContainer = "_hh-4";
export var dropdownImage = "_hh-5";
export var editAssigneeInfo = "_hh-3";
export var editAssigneeModalContainer = "_hh-6";
export var hidden = "_hh-8";
export var input = "_hh-7";